import { waypointInit } from 'helpers/utils';

const waypointConfig = {
    selector: '.map',
    funcs: [{ target: 'waypoint--left' }, { target: 'waypoint--right' }],
    offset: '80%',
};

function handleCard({ container, id }) {
    const _card = container.getElementsByClassName('js--map-card');
    const _this = container.querySelector(`.js--map-card[data-map-id="${id}"]`);
    const _activeMap = container.getElementsByClassName(`map__map--active`)[0];
    const _map = container.querySelector(`.js--map-img[data-map-img="${id}"]`);

    if (_this.classList.contains('map__card--active')) {
        return;
    }

    Array.from(_card).forEach((k) => k.classList.remove('map__card--active'));
    _this.classList.add('map__card--active');

    _activeMap.classList.remove('map__map--active');
    _map.classList.add('map__map--active');
}

const attachCardEventListeners = () =>
    Array.from(document.getElementsByClassName('js--map-card')).forEach((k) =>
        k.addEventListener('mouseenter', (e) =>
            window.innerWidth <= 960
                ? false
                : handleCard({
                      container: e.target.closest('.map'),
                      id: parseInt(e.target.getAttribute('data-map-id'), 10),
                  }),
        ),
    );

function init() {
    waypointInit(waypointConfig);
    attachCardEventListeners();
}

export default init;



// WEBPACK FOOTER //
// ./app/js/modules/map.js